var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.548401C4.48 0.548401 0 5.0284 0 10.5484C0 16.0684 4.48 20.5484 10 20.5484C15.52 20.5484 20 16.0684 20 10.5484C20 5.0284 15.52 0.548401 10 0.548401ZM10 3.5484C11.66 3.5484 13 4.8884 13 6.5484C13 8.2084 11.66 9.5484 10 9.5484C8.34 9.5484 7 8.2084 7 6.5484C7 4.8884 8.34 3.5484 10 3.5484ZM10 17.7484C7.5 17.7484 5.29 16.4684 4 14.5284C4.03 12.5384 8 11.4484 10 11.4484C11.99 11.4484 15.97 12.5384 16 14.5284C14.71 16.4684 12.5 17.7484 10 17.7484Z",
    fill: "#314380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.3796eedb50dccfc1b8d26524df76f8cf.svg";
export { ForwardRef as ReactComponent };